import { render, staticRenderFns } from "./CampaignDeliverables.vue?vue&type=template&id=12b69068&"
import script from "./CampaignDeliverables.vue?vue&type=script&lang=js&"
export * from "./CampaignDeliverables.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDeliverables.vue?vue&type=style&index=0&id=12b69068&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports